export default __webpack_public_path__ + "static/media/gradientCloud.dd1d20bc.svg";